<template>
  <div style="height: 100%;">
    <form 
      autocomplete="off" 
      style="width: 100%; max-width: 700px;" 
      @submit.prevent="IniciarSesion()">
      <div class="mt-lg-0 mt-5">
        <h1 
          class="mb-4" 
          style="color:#394A64; font-weight: 600;">
          Log in
        </h1>
        <div class="form-floating mb-3">
          <input 
            v-model="userLogin.email" 
            type="email" 
            class="form-control" 
            placeholder="name@example.com"
            autocomplete="parkiduo-username" 
            name="parkiduo-username">
          <label for="floatingInput">Email</label>
        </div>
        <div class="form-floating">
          <input 
            v-model="userLogin.password" 
            type="password" 
            class="form-control" 
            placeholder="Password"
            autocomplete="parkiduo-username" 
            name="parkiduo-username">
          <label for="floatingPassword">Password</label>
        </div>
        <div class="row m-0 mt-2 mb-5">
          <div 
            id="incorrect" 
            class="d-none text-danger col-7" 
            style="font-weight: 500;">
            <p>Credenciales incorrectas</p>
          </div>
          <div class="text-end col">
            <a 
              style="cursor: pointer;color: #15E0DD; font-weight: 500;font-size: .9rem;" 
              class="text-decoration-none"
              @click="changing_pass = true">Forget password?</a>
          </div>
        </div>

        <button 
          class="btn py-2 w-100 my-4 rounded-3"
          style="background-color: #15E0DD; font-size: 1.2rem;font-weight: 500; color: #007B79" 
          type="submit">
          Log in
        </button>

        <p class="text-center ">
          Don’t have an account yet?
          <span 
            style="cursor: pointer;color: #15E0DD;text-decoration: none;font-weight: 600; font-size: .9rem"
            @click="go_register()">
            Sign up
          </span>
        </p>
      </div>
    </form>
    <div 
      v-if="changing_pass" 
      class="modal fade show d-block z-3" 
      tabindex="-1">
      <div 
        class="h-100 w-100 position-fixed z-1" 
        @click="changing_pass = false" />
      <div class="modal-dialog d-flex align-items-center justify-content-center z-2">
        <div 
          class="modal-content p-5" 
          style="background-color: #F5F6F8;">
          <div v-if="!sended">
            <h6 class="mb-3">
              Introduce tu email:
            </h6>
            <div class="form-floating mb-3">
              <input 
                id="floatingInput" 
                v-model="email_change" 
                type="email" 
                class="form-control">
              <label for="floatingInput">Email</label>
            </div>
            <p class="text-danger">
              {{ response }}
            </p>
            <div class="row">
              <button 
                class="col-6 mx-auto btn py-2 my-2 rounded-4"
                style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 500; color: #007B79"
                @click="ChangePass">
                Enviar
              </button>
            </div>
          </div>
          <div v-else>
            <img 
              src="@/assets/tick.gif" 
              alt="Email enviada" 
              class="img-fluid w-25">
            <h3 class="text-success mb-3">
              ¡Peticion procesada!
            </h3>
            <p>Te hemos enviado un correo electronico para poder cambiar tu contraseña</p>
          </div>
        </div>
      </div>
    </div>
    <spinner-component 
      id="spinner" 
      class="d-none" />
  </div>
</template>
<script>
import axios from 'axios';
import SpinnerComponent from './SpinnerComponent.vue'
import { mapState } from 'vuex';
import router from '@/router';

export default {
  name: 'LoginComponent',
  components:{
    SpinnerComponent
  },
  props: {
    is_drawer:{
        type: Boolean,
        required:false
    }
  },
  data: function() {
    return {
      userLogin: {
        email: "",
        password: ""
      },
      changing_pass: false,
      email_change: "",
      response: "",
      sended: false
    }
  },
  computed:{
    ...mapState(['isLoggedIn']),
    ...mapState(['token']),
    ...mapState(['refresh'])
},
methods:{
  async IniciarSesion(){
    var spinner = document.getElementById("spinner")
    var incorrect = document.getElementById("incorrect")
    spinner.classList.remove("d-none")
    
    const apiUrl = process.env.VUE_APP_API_URL+'/api/token/pair';
    axios.post(apiUrl, this.userLogin)
    .then(response => {
      console.log("INICIADO")
      this.$store.dispatch('setToken', response.data); 
      incorrect.classList.add("d-none")

      // TODO: router push  
      router.push({ name: "PanelComandas" });
    })
    .catch(error => {
      console.error(error);
      incorrect.classList.remove("d-none")
      spinner.classList.add("d-none")
    });
  },
  go_register(){
    if(this.is_drawer){
      this.$emit("go-register");
    }else{
      router.push({ name: "Register" });
    }
  },
  async ChangePass(){
    if (!this.email_change){
      this.response = "Introduce un correo correcto"
      return
    }

    var spinner = document.getElementById("spinner")
    spinner.classList.remove("d-none")
    
    const apiUrl = process.env.VUE_APP_API_URL+'/api/partner/ChangePassword?email=' + this.email_change;
    axios.post(apiUrl)
    .then(response => {
      console.log(response)
      this.sended = true
      spinner.classList.add("d-none")
      setTimeout(() => {
        this.sended = false
        this.changing_pass = false
        this.email_change = ""
        this.response = ""
      }, 5000);
    })
    .catch(error => {
      console.error(error);
      this.response = "El email no corresponde a ningun cliente"
      spinner.classList.add("d-none")
    });
  },
}
}
</script>
<style scoped>
  .modal {
    background: rgba(139, 139, 139, 0.5);
  }
  .modal-dialog {
    min-height: 90vh;
  }
</style>